import { createRoot, hydrateRoot } from 'react-dom/client';
import { AppShell } from './AppShell';

declare global {
    interface Window {
        __SERVER_STATE__?: unknown;
        __CONFIG__?: AlgoliaConfig;
        __REFINEMENTS__?: AlgoliaRefinements;
        __algoliaMounted__?: boolean;
    }
}

const host = document.getElementById('algolia-instantsearch') as HTMLElement | null;
if (!host) throw new Error('#algolia-instantsearch not found');

if (window.__algoliaMounted__) {
    console.warn('[algolia] already mounted, skipping');
} else {
    window.__algoliaMounted__ = true;

    const hasSSR = host.hasChildNodes();

    if (hasSSR) {
        const appWithSSR = (
            <div suppressHydrationWarning={true}>
                <AppShell
                    domElement={host}
                    serverState={window.__SERVER_STATE__}
                    config={window.__CONFIG__}
                    refinements={window.__REFINEMENTS__}
                />
            </div>
        );
        hydrateRoot(host, appWithSSR, {
            onRecoverableError: (error: unknown) => {
                console.warn('Hydration mismatch suppressed:', error instanceof Error ? error.message : String(error));
            }
        });
        queueMicrotask(() => {
            (window as any).__APP_HYDRATED__ = true;
            window.dispatchEvent(new Event('app:hydrated'));
        });
    } else {
        const appWithoutSSR = (
            <div>
                <AppShell
                    domElement={host}
                    config={window.__CONFIG__}
                    refinements={window.__REFINEMENTS__}
                />
            </div>
        );
        createRoot(host).render(appWithoutSSR);
    }

    try { delete window.__SERVER_STATE__; } catch {}
}